import { gql } from '@apollo/client';

export const MEETINGS_QUERY = gql`
  query meetings(
    $dateFrom: DateTime
    $dateTo: DateTime
    $companyId: Int
    $source: String
    $status: String
    $calendarSourceId: String
    $callType: String
    $originationsOnly: Boolean
    $statusNot: String
    $limit: Int
    $offset: Int
  ) {
    meetings(
      dateFrom: $dateFrom
      dateTo: $dateTo
      companyId: $companyId
      source: $source
      status: $status
      calendarSourceId: $calendarSourceId
      callType: $callType
      originationsOnly: $originationsOnly
      statusNot: $statusNot
      limit: $limit
      offset: $offset
    ) {
      id
      domain
      companyId
      companyName
      title
      meetingDate
      endTime
      durationMinutes
      source
      status
      notes
      surveyEligible
      calendarSourceId
      callType
      originationsCalendarInvited
      attendees {
        id
        userId
      }
      externalAttendees {
        id
        email
        displayName
        domain
        companyId
        companyName
      }
      surveyResponses {
        id
        respondentId
        datetimeCreated
      }
    }
  }
`;

export const CALENDAR_DATA_QUERY = gql`
  query meetingsCalendarData(
    $dateFrom: DateTime!
    $dateTo: DateTime!
    $calendarSourceId: String
    $originationsOnly: Boolean
  ) {
    meetingsCalendarData(
      dateFrom: $dateFrom
      dateTo: $dateTo
      calendarSourceId: $calendarSourceId
      originationsOnly: $originationsOnly
    ) {
      id
      title
      meetingDate
      endTime
      companyId
      companyName
      domain
      status
      surveyColor
      surveyEligible
      calendarSourceId
      callType
      originationsCalendarInvited
    }
  }
`;

export const UPDATE_MEETING_COMPANY = gql`
  mutation updateMeetingCompany($meetingId: Int!, $companyId: Int!) {
    updateMeetingCompany(meetingId: $meetingId, companyId: $companyId) {
      ok
      error
      meeting {
        id
        companyId
        domain
      }
    }
  }
`;

export const CREATE_MEETING = gql`
  mutation createMeeting(
    $domain: String!
    $meetingDate: DateTime!
    $title: String
    $companyId: Int
    $durationMinutes: Int
    $attendeeUserIds: [Int]
    $externalAttendeeEmails: [String]
    $endTime: DateTime
    $notes: String
  ) {
    createMeeting(
      domain: $domain
      meetingDate: $meetingDate
      title: $title
      companyId: $companyId
      durationMinutes: $durationMinutes
      attendeeUserIds: $attendeeUserIds
      externalAttendeeEmails: $externalAttendeeEmails
      endTime: $endTime
      notes: $notes
    ) {
      ok
      error
      meeting {
        id
        domain
        companyId
        meetingDate
        title
      }
    }
  }
`;

export const MANAGE_BLOCKLIST = gql`
  mutation manageDomainBlocklist($domain: String!, $action: String!, $blocklistType: String) {
    manageDomainBlocklist(domain: $domain, action: $action, blocklistType: $blocklistType) {
      ok
      error
    }
  }
`;

export const COMPANY_SEARCH_QUERY = gql`
  query searchCompanies($query: String!) {
    searchCompanies(query: $query) {
      id
      companyName
      domain
    }
  }
`;

export const COMPANY_SURVEY_AGGREGATION = gql`
  query CompanySurveyAggregation($companyId: Int!) {
    companySurveyAggregation(companyId: $companyId) {
      totalResponses
      likertScores
      multiSelectFrequencies
      responses
    }
  }
`;

export const MARK_MEETING_ORIGINATION = gql`
  mutation markMeetingOrigination($meetingId: Int!, $companyId: Int!) {
    markMeetingOrigination(meetingId: $meetingId, companyId: $companyId) {
      ok
      error
      meeting {
        id
        surveyEligible
        companyId
        callType
      }
    }
  }
`;

export const UPDATE_MEETING_CALL_TYPE = gql`
  mutation updateMeetingCallType($meetingId: Int!, $callType: String!) {
    updateMeetingCallType(meetingId: $meetingId, callType: $callType) {
      ok
      error
      meeting {
        id
        callType
        surveyEligible
      }
    }
  }
`;

export const TRIGGER_SURVEY = gql`
  mutation TriggerSurvey($meetingId: Int!) {
    triggerSurvey(meetingId: $meetingId) {
      success
      notificationsSent
      message
    }
  }
`;

export const WATERFALL_QUERY = gql`
  query originationsWaterfall($dateFrom: DateTime!, $dateTo: DateTime) {
    originationsWaterfall(dateFrom: $dateFrom, dateTo: $dateTo) {
      bars {
        label
        count
        companyIds
      }
      funnelPercentage
      initialCallsUnvalidated
      initialCallsUnvalidatedCompanyIds
    }
  }
`;

export const USER_COCKPIT_STATS_QUERY = gql`
  query userCockpitStats($userId: Int!, $days: Int) {
    userCockpitStats(userId: $userId, days: $days) {
      userName
      validatedCompanies7d
      surveysAnswered
      surveysPendingCount
      surveysPending {
        meetingId
        title
        meetingDate
        domain
        companyName
        companyId
      }
    }
  }
`;

export const USER_WATERFALL_QUERY = gql`
  query userWaterfall($userId: Int!, $dateFrom: DateTime!, $dateTo: DateTime) {
    userWaterfall(userId: $userId, dateFrom: $dateFrom, dateTo: $dateTo) {
      bars {
        label
        count
        companyIds
      }
      funnelPercentage
    }
  }
`;

export const WATERFALL_DRILL_DOWN_QUERY = gql`
  query waterfallDrillDown($barLabel: String!, $dateFrom: DateTime!, $dateTo: DateTime) {
    waterfallDrillDown(barLabel: $barLabel, dateFrom: $dateFrom, dateTo: $dateTo) {
      companyId
      companyName
      domain
      meetingHolders
      emailSenders
      emailReceivers
    }
  }
`;
